<template>
  <div id="app">
    <link rel="stylesheet" href="//fonts.googleapis.com/css?family=Roboto:400,500,700,400italic|Material+Icons">
    <Native />
    <ToolsBar />
    <div class='content'>
      <FileList />
      <FileListDetail/>
    </div>
    
    <Footer />
  </div>
</template>

<script>

import Native from './components/Native.vue'
import Footer from './components/Footer.vue'
import ToolsBar from './components/ToolsBar.vue'
import FileList from './components/FileList.vue'
import FileListDetail from './components/FileListDetail.vue'

export default {
  name: 'app',
  components: {
    Native,
    ToolsBar,
    FileList,
    FileListDetail,
    Footer
  }
}
</script>

<style>
#app {
  background-color: rgb(223, 213, 213);
  display:flex;
  justify-content:center;
  flex-direction: column;
  min-width: 500px;
}

/* .content{
  overflow: auto;
} */

.footer{
  position: fixed;
  bottom: 0px;
}
</style>
